var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkAsNotSeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 0H1.33325V16H14.6666V4.66667H9.99992V0ZM10.6666 4V0.666667L13.9999 4H10.6666ZM5.45631 6.69037L5.44918 6.69447L4.86462 6.14645C4.65634 5.95118 4.31866 5.95118 4.11038 6.14645C3.9021 6.34171 3.9021 6.65829 4.11038 6.85355L4.58863 7.30192C3.77755 7.99042 3.11386 8.91775 2.66659 10C3.64695 12.3722 5.66703 14 7.99992 14C9.01907 14 9.97853 13.6893 10.8177 13.1416L11.2757 13.5711C11.484 13.7663 11.8217 13.7663 12.03 13.5711C12.2383 13.3758 12.2383 13.0592 12.03 12.864L11.6376 12.4961L11.6434 12.4907L10.3135 11.244L10.3093 11.2508L9.50876 10.5003L9.51174 10.4923L7.47476 8.58267L7.46624 8.58547L6.66569 7.83494L6.67298 7.831L5.45631 6.69037ZM5.33325 10C5.33325 9.43715 5.53166 8.91774 5.86647 8.4999L6.63359 9.21907C6.48535 9.44654 6.39992 9.71392 6.39992 10C6.39992 10.8284 7.11626 11.5 7.99992 11.5C8.30507 11.5 8.59028 11.4199 8.83292 11.2809L9.60003 12.0001C9.15433 12.314 8.60029 12.5 7.99992 12.5C6.52716 12.5 5.33325 11.3807 5.33325 10ZM10.6615 10.156C10.6649 10.1044 10.6666 10.0524 10.6666 10C10.6666 8.61929 9.47268 7.5 7.99992 7.5C7.94403 7.5 7.88855 7.50161 7.83352 7.50479L6.48129 6.23707C6.96615 6.08238 7.47512 6 7.99992 6C10.3328 6 12.3529 7.62785 13.3333 10C13.071 10.6346 12.7343 11.2159 12.3372 11.727L10.6615 10.156Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsNotSeen);
export default __webpack_public_path__ + "static/media/MarkAsNotSeen.42be68410afcaa5c4c1e679eb6520339.svg";
export { ForwardRef as ReactComponent };